<template lang="html">
  <main id="user-group-wrap">
    <Map :mapData="userGroupMapData" :userGroupMap="true"></Map>
  </main>
</template>

<script>
import Map from '@/components/map/Map.vue'
import Profile from '@/assets/profile/Profile.js'
import DataManager from '@/assets/DataManager.js'
import DataFunctions from '@/assets/DataFunctions.js'

export default {
  data() {
    return {
      userGroup: false,
      userGroupContent: [],
      userGroupMapData: [],
      tagList: false,
    }
  },
  props: {
    userGroupId: {
      required: true,
    }
  },
  components: {
    Map,
  },
  created() {
    this.$HelperFunctions.scrollToTop();

    Profile.getUserData().then((data) => {
      DataManager.getData([
        DataManager.tagList,
      ], (response) => {
        this.tagList = response[0].data;
        for(var i = 0; i < data.groups.length; i++) {
          if(data.groups[i].id == this.userGroupId) {
            this.userGroup = data.groups[i];
          }
        }
        this.$HelperFunctions.setPageTitle(this.userGroup.name);
        this.getUserGroupData();
      });
    });
  },
  mounted() {

  },
  methods: {
    getUserGroupData() {
      Profile.getLikeData(this.userGroup.likes, true).then((data) => {
        data.forEach((obj) => {
          if(obj.type == 'place' || obj.type == 'tag') {
            this.userGroupContent.push(obj);
          }
          else if(obj.type == 'group') {
            DataFunctions.getGroupById(obj.value).then((group) => {
              this.checkGroupData(group);
            });
          }
        });
        setTimeout(() => {
          this.processUserData();
        }, 500);
      });
    },

    checkGroupData(list) {
      //console.log(list);
  		if(list.children) {
  	    for(var i = 0; i < list.children.length; i++) {
  	      if(list.children[i].type == 'place' || list.children[i].type == 'tag') {
  	        this.userGroupContent.push(list.children[i]);
  	      }
  	      else if(list.children[i].type == 'group') {
  	        this.checkGroupData(list.children[i]);
  	      }
  	    }
  		}
    },

    processUserData() {
      this.userGroupContent.forEach((item) => {
  			if(item.archived != true && item.itemBroke != true) {
          if(item.type == 'tag') {
            this.getData(item).then((data) => {
              for(var k in data.features) {
                this.userGroupMapData.push(data.features[k]);
              }
            });
          }
          else if(item.type == 'place') {
            this.getData(item).then((data) => {
              this.userGroupMapData.push(data[0]);
            });
          }
  			}
      });
      //console.log(this.userGroupMapData);
    },

    getData(item) {
      var promise = new Promise((resolve) => {
        var tagId = (item.type == 'tag') ? parseInt(item.value) || parseInt(item.tags) : parseInt(item.primary) || parseInt(item.tagId);
        DataManager.getData([
          DataManager.newTags+tagId+'-dk-light.json',
        ], (response) => {
          var tagData = response[0].data;
          if(item.type == 'tag') {
            resolve(tagData);
          }
          else if(item.type == 'place') {
            let id = parseInt(item.value) || parseInt(item.item_id);
            let place = tagData.features.filter(feature => feature.id == id);
            resolve(place);
          }
        });
      });
      return promise;
    },
  }
}
</script>

<style lang="css" scoped>
  #user-group-wrap {
    position: relative;
    height: 100%;
    width: 100%;
  }

  /*Landscape - SM*/
  @media screen and (min-width: 768px) and (max-width: 991px) {
    #user-group-wrap {
      top: 40px;
      height: calc(100% - 40px);
    }
  }
</style>
